import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  // You'll need to replace these with your actual Firebase config values
  apiKey: "AIzaSyDWLO7SYua4WfwCfKxaEtZNGXSMCpPqp_8",
  authDomain: "stb-workshop.firebaseapp.com",
  projectId: "stb-workshop",
  storageBucket: "stb-workshop.firebasestorage.app",
  messagingSenderId: "282776560447",
  appId: "1:282776560447:web:4a330a983ada00e986698a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;